import React  from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getUserDetails } from '../../helpers/auth';
import { setUser } from '../../actions/auth';
import {setOSCChannelState} from '../../actions/notifications';
import giftIcon from '../../images/icons/giftIcon.png';
import user from '../../images/icons/duser.png';
import cart from '../../images/icons/cart.png';
import { history } from '../../routers/AppRouter';
import paths from '../../helpers/paths';
import { setProductCart, setCartTotalQuantity } from '../../actions/cart';
import { getCartDetails, setCartDetails } from '../../helpers/cart';
import { setListingID } from '../../actions/filterSearch';



class SearchBarBS extends React.Component {
  constructor(props) {
    super(props);
    this.searchSubmit = this.searchSubmit.bind(this);
    this.inputSearchProduct = React.createRef();
  }

  componentDidMount (){
    const { dispatch } = this.props; 
    // const { localState, localArea, propertyType, 
    //   categoryType, listingType } = useSelector(state => state.filterSearch);
    try{
      let retrieveCartDetails = JSON.parse(getCartDetails());
      if(retrieveCartDetails == null || retrieveCartDetails == 'null' ||
         retrieveCartDetails === undefined || retrieveCartDetails === 'undefined' ){
           setCartDetails(JSON.stringify([]));
         }else{
          let retrieveCartProduct = getCartDetails();
          let parseRetrievedCart;
          let reduceParsedCart
          parseRetrievedCart = JSON.parse(retrieveCartProduct);
          reduceParsedCart = parseRetrievedCart.map(li => li.quantity).reduce((sum, val) => parseInt(sum) + parseInt(val), 0);
          dispatch(setCartTotalQuantity(JSON.stringify(reduceParsedCart)));
          dispatch(setProductCart(retrieveCartDetails));
          setCartDetails(JSON.stringify(retrieveCartDetails))
         }
    }catch(err){
      dispatch(setProductCart([]));
      setCartDetails(JSON.stringify([]));
    };

    try{
      let retrieveUserDetails = JSON.parse(getUserDetails());
      dispatch(setUser(retrieveUserDetails));
    }catch(err){
      dispatch(setUser({}));
    };
  };

  componentWillMount(){
    window.scrollTo({top: 0, left: 0, behaviour: 'smooth'});
  };

  searchSubmit = () => {
    // console.log("hey");
    //e.preventDefault();
    const { dispatch } = this.props; 
    const productId = this.inputSearchProduct.current.value.trim();
    dispatch(setListingID(productId));
    // console.log(productId);
    // const { listingID } = this.props.filterSearch;
    // const { dispatch } = this.props; 
    // const searchStoreInput = e.target.searchProduct.value;
    // dispatch(setListingID(searchStoreInput));
    // console.log(listingID);
    // dispatch(search(product));
  };
  render(){
    const { dispatch } = this.props; 
    const { toggleAuthSettings } = this.props.css;
    const { totalQuantity } = this.props.cart;


    return (
      <div className='searchbar'>
        <table className='display-table-cell' align="center">
          <tbody>
            <tr>
              <td className='data-wider-space'>
              <Link to='/search'>
                <form onSubmit={this.searchSubmit} >
                  <input name='searchProduct' className='searchStore' type='text' 
                   placeholder='Search store' 
                   ref={this.inputSearchProduct}
                   required/>
                  
                    <button onClick={() => {
                      this.searchSubmit();
                    
                    }} className='enter-search' type='submit' value='Search' > Search </button >
                  <div className='underlineDiv'></div>
                </form>
                </Link>
              </td>
              <td className='data-wider-space'>
                <a onClick={() => {
                dispatch(setOSCChannelState(false));
                history.push(paths.contact);
              }} className='mailListRef' href='#'><u>JOIN OUR MAILING LIST FOR EXCLUSIVE DEALS</u></a>
              </td>
              <td className='data-smaller-space'>
                {false && (
                  <a onClick={() => {
                    dispatch(setOSCChannelState(true));
                  }} className='mailListRef' href='#'><img className='giftIcon' src={giftIcon}/></a>
                )}
              </td>
              <td className='data-smaller-space'>
                <a onClick={() => {
                  dispatch(setOSCChannelState(true));
                  
                }} className='mailListRef' href='#'><img className='giftIcon' src={user}/></a>
              </td>
              <td className='data-smaller-space shop-bag'>
               {false && (
                  <a onClick={() =>{
                    dispatch(setOSCChannelState(true));
                     
                    }} className='mailListRef' href='#'><img className='giftIcon' src={cart} /> 
                    {`(${totalQuantity})`} Bag
                  </a>
               )}
              </td>
            </tr> 
          </tbody> 
        </table>
      </div>
    );
  };
};

const mapStateToProps = (state) => state;

export default connect(mapStateToProps)(SearchBarBS); 
